import { useMenuChucNang } from "@hooks/useMenuChucNang";
import routerConstants from "./routerConstants";
import {
    TeamOutlined,
    ShopOutlined,
    TagsOutlined,
    ShoppingOutlined,
    ShoppingCartOutlined,
    FileTextOutlined,
    CarOutlined,
    SyncOutlined,
    KeyOutlined,
    EnvironmentOutlined,
} from '@ant-design/icons';
import { CHUC_NANG_PERMISSION_CODES } from './permissionConstants';

interface IMenu {
    key: string;
    startPoint: string;
    path: string;
    label: string;
    icon: any;
    children: IMenu[];
}

export const userMenu = () => {
    const { hasMenu, hasChucNangByCode } = useMenuChucNang();

    let menuApps: IMenu[] = [];

    const getMenu1 = () => {
        const availableMenus: IMenu[] = [];
        if (hasMenu(routerConstants.customer.list)) {
            availableMenus.push({ key: 'customer', startPoint: routerConstants.customer.name, path: routerConstants.customer.list, label: 'Khách hàng', icon: TeamOutlined, children: [] });
        }

        if (hasMenu(routerConstants.category.list)) {
            availableMenus.push({ key: 'category', startPoint: routerConstants.category.name, path: routerConstants.category.list, label: 'Danh mục hàng', icon: TagsOutlined, children: [] });
        }

        if (hasMenu(routerConstants.product.list)) {
            availableMenus.push({ key: 'product', startPoint: routerConstants.product.name, path: routerConstants.product.list, label: 'Sản phẩm', icon: ShoppingOutlined, children: [] });
        }
        if (hasMenu(routerConstants.kiotRetailer.saleLogin) || hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_DUAN_MANGE)) {
            availableMenus.push({
                key: 'kiotRetailerSaleLogin',
                startPoint: routerConstants.kiotRetailer.name,
                path: routerConstants.kiotRetailer.saleLogin,
                label: 'Đăng nhập Kiot (sale)',
                icon: KeyOutlined,
                children: [],
            });
        }
        if (hasMenu(routerConstants.chiNhanh.capNhatThongTin) || hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_CHINHANH_MANGE)) {
            availableMenus.push({
                key: 'chiNhanhCapNhatThongTin',
                startPoint: routerConstants.chiNhanh.name,
                path: routerConstants.chiNhanh.capNhatThongTin,
                label: 'Thông tin chi nhánh',
                icon: EnvironmentOutlined,
                children: [],
            });
        }
        return availableMenus;
    }

    const getMenu2 = () => {
        const availableMenus: IMenu[] = [];
        if (hasMenu(routerConstants.order.donHangAll)) {
            availableMenus.push({ key: 'orderAll', startPoint: routerConstants.order.donHangAll, path: routerConstants.order.donHangAll, label: 'Tất cả đơn hàng', icon: ShoppingCartOutlined, children: [] });
        }
        if (hasMenu(routerConstants.order.donHangManage)) {
            availableMenus.push({ key: 'orderManage', startPoint: routerConstants.order.donHangManage, path: routerConstants.order.donHangManage, label: 'Gán nhân viên', icon: TeamOutlined, children: [] });
        }
        if (hasMenu(routerConstants.order.donHangPick)) {
            availableMenus.push({ key: 'orderPick', startPoint: routerConstants.order.donHangPick, path: routerConstants.order.donHangPick, label: 'Nhặt hàng', icon: ShoppingOutlined, children: [] });
        }
        if (hasMenu(routerConstants.order.donHangCheck)) {
            availableMenus.push({ key: 'orderCheck', startPoint: routerConstants.order.donHangCheck, path: routerConstants.order.donHangCheck, label: 'Kiểm hàng', icon: FileTextOutlined, children: [] });
        }
        if (hasMenu(routerConstants.order.donHangPack)) {
            availableMenus.push({ key: 'orderPack', startPoint: routerConstants.order.donHangPack, path: routerConstants.order.donHangPack, label: 'Đóng hàng', icon: TagsOutlined, children: [] });
        }
        if (hasMenu(routerConstants.order.donHangSchedule)) {
            availableMenus.push({ key: 'orderSchedule', startPoint: routerConstants.order.donHangSchedule, path: routerConstants.order.donHangSchedule, label: 'Điều phối', icon: ShopOutlined, children: [] });
        }
        if (hasMenu(routerConstants.order.donHangShip)) {
            availableMenus.push({ key: 'orderShip', startPoint: routerConstants.order.donHangShip, path: routerConstants.order.donHangShip, label: 'Giao hàng', icon: CarOutlined, children: [] });
        }
        if (hasMenu(routerConstants.order.donHangSync)) {
            availableMenus.push({ key: 'orderSync', startPoint: routerConstants.order.donHangSync, path: routerConstants.order.donHangSync, label: 'Đồng bộ', icon: SyncOutlined, children: [] });
        }
        return availableMenus;
    }

    const getMenu3 = () => {
        const availableMenus: IMenu[] = [];
        if (hasMenu(routerConstants.report.list)) {
            availableMenus.push({
                key: 'report',
                startPoint: routerConstants.report.name,
                path: routerConstants.report.list,
                label: 'Báo cáo',
                icon: FileTextOutlined,
                children: [
                    {
                        key: 'reportDetail',
                        startPoint: routerConstants.report.list,
                        path: routerConstants.report.list,
                        label: 'Chi tiết đơn hàng',
                        icon: FileTextOutlined,
                        children: [],
                    },
                    {
                        key: 'reportOrder',
                        startPoint: routerConstants.report.orderList,
                        path: routerConstants.report.orderList,
                        label: 'Theo đơn (workflow)',
                        icon: FileTextOutlined,
                        children: [],
                    },
                ],
            });
        }
        return availableMenus;
    }

    const getMenu4 = () => {
        const availableMenus: IMenu[] = [];
        if (hasMenu(routerConstants.syncKiot.sync)) {
            availableMenus.push({ key: 'syncKiot', startPoint: routerConstants.syncKiot.name, path: routerConstants.syncKiot.sync, label: 'KIOT', icon: SyncOutlined, children: [] });
        }
        return availableMenus;
    }

    // get menu 
    const menu1 = getMenu1();
    const menu2 = getMenu2();
    const menu3 = getMenu3();
    const menu4 = getMenu4();
    
    if (menu1.length > 0) {
        menuApps.push({
            key: 'kiot',
            startPoint: "/kiot/",
            path: '',
            label: 'Kiot',
            icon: ShopOutlined,
            children: menu1
        });
    }

    if (menu2.length > 0) {
        menuApps.push({
            key: 'kho',
            startPoint: "/kho/",
            path: '',
            label: 'Đơn hàng',
            icon: ShoppingCartOutlined,
            children: menu2
        });
    }
   
    if (menu3.length > 0) {
        menuApps = [...menuApps, ...menu3]
    }

    if (menu4.length > 0) {
        menuApps = [...menuApps, ...menu4]
    }
    return menuApps;
}